export const _translations = {
	legacy: false,
	locale: 'de',
	messages: {
		en: {
			files: {
				header: {
					title: 'Files',
					subtitle: 'Drag files here to upload.',
					selectFiles: 'Select files',
					uploadManualAria: 'Upload files manually',
					uploadFallbackAria: 'Upload files (fallback)',
				},
				states: {
					loading: 'Loading files ...',
					empty: 'No files found.',
					adminOnly: 'Only admins can upload files.',
					selectTarget: 'Please select a project or location before uploading.',
					uploadFailed: 'Failed to upload files',
				},
				overlay: {
					title: 'Drop files to upload',
					subtitle: 'They will be uploaded immediately to the current folder.',
				},
				uploadDropdown: {
					title: 'Recent uploads',
					subtitle: 'Files upload automatically after dropping.',
					close: 'Close',
					emptyTitle: 'No uploads yet.',
					emptySubtitle: 'Start an upload to track it here.',
					statusDone: 'Done',
					statusError: 'Error',
					statusUploading: 'Uploading',
					statusQueued: 'Queued',
				},
				preview: {
					downloadPdf: 'Download PDF',
					loading: 'Loading file…',
					pdfUnsupported: 'It appears your browser cannot display PDFs.',
					noPreview: 'No preview available for {name}.',
					audioUnsupported: 'Your browser does not support the audio element.',
					videoUnsupported: 'Your browser does not support the video element.',
					download: 'Download',
				},
				recursive: {
					zip: 'Zip',
					deleteTitle: 'Delete file',
					deletePrompt: 'Are you sure you want to delete this file?',
					loading: 'Loading',
					loadingFolder: 'Loading folder ...',
					empty: 'Empty folder',
				},
			},
		},
		de: {
			files: {
				header: {
					title: 'Dateien',
					subtitle: 'Dateien hierher ziehen zum Hochladen.',
					selectFiles: 'Dateien auswählen',
					uploadManualAria: 'Dateien manuell hochladen',
					uploadFallbackAria: 'Dateien hochladen (Fallback)',
				},
				states: {
					loading: 'Dateien werden geladen ...',
					empty: 'Keine Dateien gefunden.',
					adminOnly: 'Nur Admins können Dateien hochladen.',
					selectTarget: 'Bitte wähle zuerst ein Projekt oder einen Standort.',
					uploadFailed: 'Dateien konnten nicht hochgeladen werden',
				},
				overlay: {
					title: 'Dateien zum Hochladen ablegen',
					subtitle: 'Sie werden sofort in den aktuellen Ordner hochgeladen.',
				},
				uploadDropdown: {
					title: 'Letzte Uploads',
					subtitle: 'Dateien werden nach dem Ablegen automatisch hochgeladen.',
					close: 'Schließen',
					emptyTitle: 'Noch keine Uploads.',
					emptySubtitle: 'Starte einen Upload, um ihn hier zu sehen.',
					statusDone: 'Fertig',
					statusError: 'Fehler',
					statusUploading: 'Wird hochgeladen',
					statusQueued: 'Wartend',
				},
				preview: {
					downloadPdf: 'PDF herunterladen',
					loading: 'Datei wird geladen…',
					pdfUnsupported: 'Ihr Browser kann PDFs nicht anzeigen.',
					noPreview: 'Keine Vorschau verfügbar für {name}.',
					audioUnsupported: 'Ihr Browser unterstützt das Audio-Element nicht.',
					videoUnsupported: 'Ihr Browser unterstützt das Video-Element nicht.',
					download: 'Download',
				},
				recursive: {
					zip: 'Zip',
					deleteTitle: 'Datei löschen',
					deletePrompt: 'Soll diese Datei wirklich gelöscht werden?',
					loading: 'Lädt',
					loadingFolder: 'Ordner wird geladen ...',
					empty: 'Ordner ist leer',
				},
			},
		},
	},
}
